import { useSortable } from "@dnd-kit/sortable";

const RowDragHandleCell = ({ rowId }) => {
  const { attributes, listeners } = useSortable({
    id: rowId,
  });

  return (
    <button {...attributes} {...listeners}>
      🟰
    </button>
  );
};

export const baseSortColumn = () => {
  return [
    {
      id: "drag-handle",
      header: "",
      cell: ({ row }) => (
        <div className="flex items-center justify-center">
          <RowDragHandleCell rowId={row.id} />
        </div>
      ),
      size: 20,
    },
  ];
};
